import { IconAttachment, IconCloseCircle, IconPlus } from '@arco-design/web-react/icon';

import './PostAttachments.css';
import { Button } from '@arco-design/web-react';
import { MAX_IMAGES_COUNT } from '../../constants';

interface PostAttachmentsPreviewProps {
  documentFile?: File;
  document_url?: string;
  file_name?: string;
  images?: string[];
  imageFiles?: File[];
  onAddImageFile: () => void;
  onRemoveDocument: () => void;
  onRemoveDocumentFile: () => void;
  onRemoveImage: (url: string) => void;
  onRemoveImageFile: (name: string) => void;
}

export const PostAttachmentsPreview = ({ documentFile, document_url, file_name, images, imageFiles, onAddImageFile, onRemoveDocument, onRemoveDocumentFile, onRemoveImage, onRemoveImageFile }: PostAttachmentsPreviewProps) => {
  const totalImages = (images?.length || 0) + (imageFiles?.length || 0);

  return (
    <div className="post-attachments__wrapper">

      {document_url ? (
        <div className='file-preview'>
          <IconAttachment />
          <span>{file_name}</span>
          <IconCloseCircle className="remove-icon" onClick={onRemoveDocument} />
        </div>
      ) : documentFile && (
          <div className='file-preview'>
            <IconAttachment />
            <span>{documentFile.name}</span>
            <IconCloseCircle className="remove-icon" onClick={onRemoveDocumentFile} />  
          </div>
        )
      }

      <div className="image-previews small">
        {!!imageFiles && imageFiles.map((file) => (
          <div key={file.name} className="image-preview small">
            <img
              className="image-preview__image small"
              src={URL.createObjectURL(file)}
              alt={`Preview ${file.name}`}
            />
            <button
              className="delete-image-button"
              onClick={() => onRemoveImageFile(file.name)}
            >
              <IconCloseCircle className="delete-image-button-icon" />
            </button>
          </div>
        ))}


        {images && images.length > 0 && images.map((image_url, index) => {
            return image_url && (<div key={index} className="image-preview small">
              <img
                className="image-preview__image small"
                src={image_url}
                alt={`Preview ${index}`}
              />
              <button
                className="delete-image-button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onRemoveImage(image_url)}}
              >
                <IconCloseCircle className="delete-image-button-icon" />
              </button>
              </div>)
          })
        } 

        {
        totalImages > 0 && totalImages < MAX_IMAGES_COUNT && (
          <Button
            onClick={onAddImageFile}
            icon={<IconPlus />}
          />
          )
        }

      </div>


    </div>
  )
}
